import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { cond, equals, always, T } from 'ramda';
import { Container, ContinueButton, Content, ButtonWrapper } from './booking.styles';
import messages from './booking.messages';
import { Overlay } from '../../shared/components/overlay';
import { BookingStep } from './booking.constants';
import { DateSelection } from './dateSelection';
import { Summary } from './summary';
import { GuestsSelection } from './guestsSelection';
import Payment from './payment/payment.container';
import { StepRouter } from './stepRouter';
import { resetScroll } from '../../shared/utils/scroll';
import { DotSeparatedTitle } from '../../shared/components/dotSeparatedTitle';
import { Helmet } from '../../shared/components/helmet';

export class Booking extends PureComponent {
  static propTypes = {
    startBooking: PropTypes.func,
    closeBooking: PropTypes.func,
    step: PropTypes.number,
    experienceHomeUrl: PropTypes.string,
    experience: PropTypes.object,
    theme: PropTypes.object,
    intl: PropTypes.object,
    nextStep: PropTypes.func.isRequired,
    isStepFilled: PropTypes.bool,
    previousStep: PropTypes.func.isRequired,
    resetBooking: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.startBooking();
  }

  componentDidUpdate(prevProps) {
    const { step, theme } = this.props;
    const { step: prevStep, theme: prevTheme } = prevProps;

    const stepHasChanged = prevStep !== step;
    const transitionHasFinished = prevTheme.isTransitioning && !theme.isTransitioning;

    if (stepHasChanged || transitionHasFinished) {
      resetScroll();
    }
  }

  componentWillUnmount() {
    this.props.resetBooking();
  }

  get headerTitle() {
    const { intl, step, experience } = this.props;
    const base = experience.name;
    const stepTitle = messages[`step${step}Title`] && intl.formatMessage(messages[`step${step}Title`]);

    return <DotSeparatedTitle mainText={base} secondaryText={stepTitle} />;
  }

  isStep = step => this.props.step === step;

  handleNextClick = this.props.nextStep;

  handlePreviousClick = this.props.previousStep;

  renderContent = cond([
    [equals(BookingStep.TIME), always(<DateSelection />)],
    [equals(BookingStep.PARTICIPANTS), always(<GuestsSelection />)],
    [equals(BookingStep.SUMMARY), always(<Summary />)],
    [equals(BookingStep.PAYMENT), always(<Payment />)],
  ]);

  renderDefaultButton = () => (
    <ButtonWrapper>
      <ContinueButton onClick={this.handleNextClick} disabled={!this.props.isStepFilled}>
        <FormattedMessage {...messages.continueLabel} />
      </ContinueButton>
    </ButtonWrapper>
  );

  renderButton = cond([
    [equals(BookingStep.SUMMARY), always(null)],
    [equals(BookingStep.PAYMENT), always(null)],
    [T, this.renderDefaultButton],
  ]);

  render() {
    const { step, closeBooking } = this.props;

    return (
      <Overlay
        onBackClicked={this.handlePreviousClick}
        step={this.isStep(BookingStep.SUMMARY) ? undefined : step}
        title={this.headerTitle}
        onClose={closeBooking}
      >
        <Helmet title={this.props.experience.name} />

        <StepRouter>
          <Container>
            <Content>{this.renderContent(step)}</Content>
            {this.renderButton(step)}
          </Container>
        </StepRouter>
      </Overlay>
    );
  }
}
